export const SetTaskSorting = 'sort/task/SET'
